import  React , { useState } from "react";
import Box from "@mui/material/Box";
import { TextField, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
	getScenariosForApproval,
	rejectScenario,
	setState,
} from "./scenarioApprovalSlice";
import DeleteIcon from '@mui/icons-material/Delete';

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	boxShadow: 24,
	borderRadius: 1,
	p: 3,
};

export default function RejectScenarioModal() {
	const dispatch = useDispatch();
	const [uploadedEditFile, setuploadedEditFile] = useState([]);
	const {
		rejectScenarioModalOpen,
		scenarioDetails,
		selectedPeriod,
		selectedScenarioStatus,
		selectedCountryID,
		rejectSelectedComment,
		files,
		searchText
	} = useSelector((store) => store.scenarioApproval);

	if (scenarioDetails === null) {
		return null;
	}

	const handleOpen = () => {
		dispatch(setState("rejectScenarioModalOpen", true));
	};
	function setComment(event) {
		const comment = event.target.value;
		dispatch(setState("rejectSelectedComment", comment));
	 }
	const handleClose = () => {
		dispatch(setState("rejectScenarioModalOpen", false));
		dispatch(setState("rejectSelectedComment",''));
		dispatch(setState("files",[]));
		setuploadedEditFile([]);
	};

	function search() {
		dispatch(setState("scenarioDetails", null));
		dispatch(setState("rejectSelectedComment",''));
		dispatch(setState("selectedRows",[]));
		dispatch(setState("files",[]));
		setuploadedEditFile([]);
		const logedUser = JSON.parse(localStorage.getItem("data"));
		const period = selectedPeriod;
		const scenarioStatus = selectedScenarioStatus;
		const countryId = selectedCountryID;
		const obj = {
			logedUser,
			period,
			scenarioStatus,
			searchText,
			countryId
		};
		dispatch(getScenariosForApproval(obj));
	}

	function preparePayload() {
		const user = JSON.parse(localStorage.getItem("data"));
		const scenario = scenarioDetails;
		console.log(scenario);
		console.log(user);
		const country = user.userCountries.find(
			(index) => index.country.countryID === scenario.countryID
		).country;

		const formData = new FormData();
		formData.append("countryID", scenario.countryID);
		formData.append("countryName", country.countryName);
		formData.append("countryCode", country.countryCode);
		formData.append(
			"countrySalesOrganizationCode",
			country.countrySalesOrganizationCode
		);
		formData.append("scenarioID", scenario.scenarioID);
		formData.append("effectiveStartDate", scenario.effectiveStartDate);
		formData.append("effectiveEndDate", scenario.effectiveEndDate);
		formData.append("scenarioName", scenario.scenarioName);
		formData.append("scenarioStatus", scenario.scenarioStatus);
		formData.append("updatedBy", scenario.updatedBy);
		formData.append("updatedDate", scenario.updatedDate);
		formData.append("createdBy", scenario.createdBy);
		formData.append("createdDate", scenario.createdDate);
		// formData.append("rejectionComments", "");
		formData.append("canApproveReject", true);
		//formData.append("tranOptions[timeout]", scenario.tranOptions.timeout);
		// formData.append(
		// 	"tranOptions[isolationLevel]",
		// 	scenario.tranOptions.isolationLevel
		// );
		formData.append("user[userID]", user.userID);
		formData.append("user[firstName]", user.firstName);
		formData.append("user[lastName]", user.lastName);
		formData.append("user[email]", user.email);
		formData.append("user[roleID]", user.roleID);
		formData.append("user[roleName]", user.roleName);
		formData.append("user[isAdmin]", user.isAdmin);
		formData.append("user[activeFlag]", user.activeFlag);
		formData.append("user[isFirstTimeUser]", user.isFirstTimeUser);
		formData.append("user[passwordChangeDate]", user.passwordChangeDate);
		formData.append("user[isIMSUser]", user.isIMSUser);
		formData.append("rejectionComments", rejectSelectedComment);
		for (var i = 0; i < files.length; i++) {
			formData.append("files", files[i]);
		}

		user.userCountries.forEach((country, index) => {
			formData.append(
				`user[userCountries][${index}][userID]`,
				country.userID
			);
			formData.append(
				`user[userCountries][${index}][country][countryID]`,
				country.country.countryID
			);
			formData.append(
				`user[userCountries][${index}][country][countryName]`,
				country.country.countryName
			);
			formData.append(
				`user[userCountries][${index}][country][countryCode]`,
				country.country.countryCode
			);
			formData.append(
				`user[userCountries][${index}][country][countrySalesOrganizationCode]`,
				country.country.countrySalesOrganizationCode
			);
		});

		user.userCustomerTypes.forEach((type, index) => {
			formData.append(
				`user[userCustomerTypes][${index}][userID]`,
				type.userID
			);
			formData.append(
				`user[userCustomerTypes][${index}][customerTypeBO][customerTypeCode]`,
				type.customerTypeBO.customerTypeCode
			);
			formData.append(
				`user[userCustomerTypes][${index}][customerTypeBO][customerTypeName]`,
				type.customerTypeBO.customerTypeName
			);
		});
		formData.append("user[token]", user.token);

		return formData;
	}

	function reject() {
		const formData = preparePayload();
		for (const pair of formData.entries()) {
			console.log(pair[0] + ", " + pair[1]);
		}
		dispatch(rejectScenario(formData)).then(()=>{
			handleClose();
			search();
		});
	}
	const handleFileUpload = (event) => {
		const fileObj = event.target.files[0];
		let files = [...uploadedEditFile];
		files.push(fileObj);
		setuploadedEditFile(files);
		dispatch(setState("files", files));
	  };
	
	  const handleDelete = (name) => {
		const files = uploadedEditFile.filter((file) => file.name !== name);
		setuploadedEditFile(files);
		dispatch(setState("files", files));
	  };

	return (
		<div>
			<Modal
				open={rejectScenarioModalOpen}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<strong>Reject:</strong>&nbsp;{scenarioDetails.scenarioName}
					<br />
					<Typography variant="subtitle2">Comments</Typography>
					<TextField
						className={'fullWidth'}
						size="large"
						multiline
						rows={6}
						style={{overflowY:'auto'}}
						value={rejectSelectedComment}
						onChange={setComment}
					/>
					               <br />
               <Grid item>
            <Box>
              <input
                type="file"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
                id="fileInput"
                onclick="fileInput.value = null"
                value=""
              />
              <label htmlFor="fileInput">
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "skyBlue.main",
                    color: "blue.main",
                    textTransform: "none",
                    mt: 1,
                    "&:hover": {
                      bgcolor: "blue.main",
                      color: "white.main",
                    },
                  }}
                  component="span"
                >
                  Upload File
                </Button>
              </label>
            </Box>
          </Grid>
          <Grid>
         {uploadedEditFile.map((file) => (
        <Box>
            <div className="file-display">
              <span>{file.name}</span>
              <Button variant="outlined" color="secondary" onClick={() => handleDelete(file.name)}>
                <DeleteIcon />
              </Button>
            </div>
        </Box>
      ))}
      </Grid>
          <br />
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<br />
						<Button
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								mr: 2,
								"&:hover": {
									bgcolor: "skyBlue.main",
									color: "black.main",
								},
							}}
							onClick={handleClose}
						>
							Close
						</Button>

						<Button
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								"&:hover": {
									bgcolor: "skyBlue.main",
									color: "black.main",
								},
							}}
							onClick={reject}
						>
							Reject
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
}
